import { ErrorCodes } from "../../proto/generated/common";

export interface ParsedError {
  errorCode: ErrorCodes | null;
  message: string | null;
}
const stringToErrorCode = Object.fromEntries(
  Object.entries(ErrorCodes)
    .filter(([key, value]) => typeof value === 'number')
    .map(([key, value]) => [key.toUpperCase(), value as ErrorCodes])
) as Record<string, ErrorCodes>;

function mapStringToErrorCode(code: string | undefined): ErrorCodes | null {
  if (!code) return null;
  return stringToErrorCode[code.toUpperCase()] ?? null;
}

export function parseErrorFromArrayBuffer(err: any): ParsedError {
  let errorCode: ErrorCodes | null = null;
  let message: string | null = null;

  const arrayBuffer = err?.response?.data;
  if (arrayBuffer instanceof ArrayBuffer) {
    try {
      const uint8 = new Uint8Array(arrayBuffer);
      const text = new TextDecoder('utf-8').decode(uint8);

      try {
        const json = JSON.parse(text);
        errorCode = mapStringToErrorCode(json.errorCode);
        message = json.message ?? null;
      } catch {
        for (const codeKey in stringToErrorCode) {
          if (text.toUpperCase().includes(codeKey)) {
            errorCode = stringToErrorCode[codeKey];
            break;
          }
        }
        message = text;
      }
    } catch (decodeErr) {
      console.error('Failed to decode error response:', decodeErr);
    }
  }

  return { errorCode, message };
}
